import { render } from "./FixPriceControlPanelComponent.vue?vue&type=template&id=0b1e1286"
import script from "./FixPriceControlPanelComponent.vue?vue&type=script&lang=js"
export * from "./FixPriceControlPanelComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen2/autoringen2.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/themes/default/js/components/lots/fixprice/FixPriceControlPanelComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b1e1286"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b1e1286', __exports__)) {
    console.log('reload')
    api.reload('0b1e1286', __exports__)
  }
  
  module.hot.accept("./FixPriceControlPanelComponent.vue?vue&type=template&id=0b1e1286", () => {
    console.log('re-render')
    api.rerender('0b1e1286', render)
  })

}


export default __exports__